import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BModal = _resolveComponent("BModal");
  return _openBlock(), _createBlock(_component_BModal, {
    modelValue: $options.show,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.show = $event),
    key: _ctx.updateKey,
    bodyBgVariant: $options.bodyBgVariant,
    bodyClass: $options.bodyClass,
    bodyTextVariant: $options.bodyTextVariant,
    busy: $options.busy,
    buttonSize: $options.buttonSize,
    cancelDisabled: $options.cancelDisabled,
    cancelTitle: $options.cancelTitle,
    cancelVariant: $options.cancelVariant,
    centered: $options.centered,
    contentClass: $options.contentClass,
    dialogClass: $options.dialogClass,
    footerBgVariant: $options.footerBgVariant,
    footerBorderVariant: $options.footerBorderVariant,
    footerClass: $options.footerClass,
    footerTextVariant: $options.footerTextVariant,
    fullscreen: $options.fullscreen,
    headerBgVariant: $options.headerBgVariant,
    headerBorderVariant: $options.headerBorderVariant,
    headerClass: $options.headerClass,
    headerCloseLabel: $options.headerCloseLabel,
    headerCloseWhite: $options.headerCloseWhite,
    headerTextVariant: $options.headerTextVariant,
    hideBackdrop: $options.hideBackdrop,
    hideFooter: $options.hideFooter,
    hideHeader: $options.hideHeader,
    hideHeaderClose: $options.hideHeaderClose,
    id: $options.id,
    modalClass: $options.modalClass,
    noCloseOnBackdrop: $options.noCloseOnBackdrop,
    noCloseOnEsc: $options.noCloseOnEsc,
    noFade: $options.noFade,
    noFocus: $options.noFocus,
    okDisabled: $options.okDisabled,
    okOnly: $options.okOnly,
    okTitle: $options.okTitle,
    okVariant: $options.okVariant,
    scrollable: $options.scrollable,
    show: $options.show,
    size: $options.size,
    title: $options.title,
    titleClass: $options.titleClass,
    titleSrOnly: $options.titleSrOnly,
    titleTag: $options.titleTag
  }, {
    title: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("div", {
      id: "main-modal-title"
    }, null, -1)]))]),
    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createElementVNode("div", {
      id: "main-modal-content"
    }, null, -1)]))]),
    footer: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createElementVNode("div", {
      id: "main-modal-footer"
    }, null, -1)]))]),
    "header-close": _withCtx(() => [...(_cache[4] || (_cache[4] = []))]),
    _: 1
  }, 8, ["modelValue", "bodyBgVariant", "bodyClass", "bodyTextVariant", "busy", "buttonSize", "cancelDisabled", "cancelTitle", "cancelVariant", "centered", "contentClass", "dialogClass", "footerBgVariant", "footerBorderVariant", "footerClass", "footerTextVariant", "fullscreen", "headerBgVariant", "headerBorderVariant", "headerClass", "headerCloseLabel", "headerCloseWhite", "headerTextVariant", "hideBackdrop", "hideFooter", "hideHeader", "hideHeaderClose", "id", "modalClass", "noCloseOnBackdrop", "noCloseOnEsc", "noFade", "noFocus", "okDisabled", "okOnly", "okTitle", "okVariant", "scrollable", "show", "size", "title", "titleClass", "titleSrOnly", "titleTag"]);
}